<template>
  <div class="mt-4">
    <h4 class="text- mb-4" v-if="transactions && transactions.length">
      СТАТУС ОПЛАТЫ: <span class="text-info text-uppercase">{{ paidStatus }}</span>
    </h4>
    <h4 class="text-danger" v-if="!serviceStatus">Заполните данные</h4>
    <h4 class="text-danger" v-else>Данные успешно заполнены</h4>

    <table class="table border" v-if="data">
      <thead>
        <tr>
          <td>{{ "name" | setText("Название") }}</td>
          <td>Статус</td>
          <td></td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(d, key) in data" :key="key" class="mb-3">
          <td>{{ key + 1 }}. {{ d.service.name }} ({{ d.model.name }})</td>
          <td>
            <span class="text-info">{{
              d.model.status === "done" ? "Выполнено" : "В процессе"
            }}</span>
          </td>

          <td class="text-right">
            <div>
              <label v-if="d.model_type === 'certificate'">
                Сформируйте заявку на получение сертификата</label
              >
              <label v-else-if="d.model_type === 'trade-in'">
                Загрузите договор Trade-In</label
              >
            </div>
            <button
              @click="showOrderService(d.id)"
              class="ml-2 btn btn-info btn-sm btn-table"
            >
              <span class="ti-arrow-right"></span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: "products",
  props: {
    data: {
      default: function () {
        return [];
      },
    },
    transactions: {
      default: function () {
        return [];
      },
    },
  },
  created() {},
  computed: {
    paidStatus() {
      for (let i = 0; i < this.transactions.length; i++) {
        if (
          this.transactions[i].client_confirmed &&
          this.transactions[i].system_confirmed
        ) {
          return "Оплачено";
        }
      }
      return "Не оплачено";
    },
    serviceStatus() {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].model.status != "done") {
          return false;
        }
      }
      return true;
    },
  },
  methods: {
    showOrderService(id) {
      let query = Object.assign({}, this.$route.query);
      if (query["item_order_service"] == id) {
        return false;
      }
      if (query["item_order_service"]) {
        delete query["item_order_service"];
      }
      query["item_order_service"] = id;
      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },
  },
  data() {
    return {};
  },
};
</script>
